module.exports = __webpack_public_path__ + "img/07.702757c9.jpg";